import { useState } from 'react';
import { Checkbox, DefaultFooterComponent, Label, Popup } from '@silverfort/sf-components';
import { useCreateBulkPolicy } from './useCreateBulkPolicy';
import {useServiceAccountContext} from "../contexts/ServiceAccountContext";

export const BulkPolicyDialog = ({
    open,
    title,
    content,
    onClose,
    action,
}: {
    open: boolean;
    title: string;
    content: string;
    onClose: () => void;
    action: string;
}) => {
    const {
        onServiceAccountUpdatePolicy,
        selectedServiceAccounts,
    } = useServiceAccountContext();
    const [sendToSiem, setSendToSiem] = useState(false);
    const { createBulkPolicy } = useCreateBulkPolicy(selectedServiceAccounts, action, sendToSiem);

    return (
        <div>
            <Popup
                open={open}
                title={title}
                ContentComponent={() => (
                    <div className="font-sf">
                        {content}
                        <div className="flex items-center gap-2 py-4">
                            <Checkbox
                                name="send to siem"
                                checked={sendToSiem}
                                onChange={(e) => setSendToSiem(e.target.checked)}
                            />
                            <Label text="Send policy violations to SIEM" className="font-normal" />
                        </div>
                    </div>
                )}
                FooterComponent={DefaultFooterComponent}
                FooterComponentProps={{
                    primaryButtonProps: {
                        text: 'Yes'
                    },
                    secondaryButtonProps: {
                        text: 'No'
                    }
                }}
                onApprove={async () => {
                    await createBulkPolicy();
                    onServiceAccountUpdatePolicy(selectedServiceAccounts.map((selectedSA) => selectedSA.guid));
                    onClose();
                    setSendToSiem(false);
                }}
                onClose={async () => {
                    setSendToSiem(false);
                    onClose();
                }}
                popupClassName="w-[360px] max-h-[256px] "
            />
        </div>
    );
};
